module.exports = __webpack_public_path__ + "img/trace_code.a07104ee.png";